import { Box, Stack, Typography } from "@mui/material";

import type { IPlace } from "@bbj-types/address";
import { Places } from "@inputs/autocomplete/Places";

export interface IFilterLocationPlacesProps {
  places: IPlace[];
  placeholder?: string;
  onChange: (places: IPlace[]) => void;
  icon?: React.ReactNode;
}

export const FilterLocationPlaces = ({ places, placeholder, onChange, icon }: IFilterLocationPlacesProps) => {
  return (
    <Stack sx={{ gap: 1, width: "100%" }}>
      <Stack gap={1} sx={{ alignItems: "center", flexDirection: "row", gap :1 }}>
        {icon && <Box sx={{ display: "flex", alignItems: "center", mr: 0.5 }}>{icon}</Box>}
        <Typography variant="body1SemiBold">
          Lieux d'accueil{" "}
          <Typography sx={{ display: "inline" }} variant="body1">
            (villes, départements, régions)
          </Typography>
        </Typography>
      </Stack>
      <Box>
        <Places
          value={places}
          onChange={(_, value) => onChange(value)}
          fullWidth
          size="small"
          color="secondary"
          placeholder={placeholder}
        />
      </Box>
    </Stack>
  );
};
